// components/OrderTypeTabs.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStore, faTruck } from "@fortawesome/free-solid-svg-icons";

const OrderTypeTabs = ({ orderType, onTabChange, isLoading }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-1 mb-6 flex gap-1">
      <button
        onClick={() => onTabChange(1)}
        disabled={isLoading}
        className={`flex-1 py-3 px-4 rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 ${
          orderType === 1
            ? 'bg-orange-500 text-white shadow-md'
            : 'text-gray-600 hover:bg-gray-100'
        } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <FontAwesomeIcon icon={faTruck} />
        Delivery
      </button>
      <button
        onClick={() => onTabChange(2)}
        disabled={isLoading}
        className={`flex-1 py-3 px-4 rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 ${
          orderType === 2
            ? 'bg-orange-500 text-white shadow-md'
            : 'text-gray-600 hover:bg-gray-100'
        } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <FontAwesomeIcon icon={faStore} />
        Pickup
      </button>
    </div>
  );
};

export default OrderTypeTabs;